import { createVisibilityStore } from '@shared/libs/tools';

export const mobileMenuActivity = createVisibilityStore();
